export const GET_DEGREE_REQUIREMENTS = 'GET_DEGREE_REQUIREMENTS';
export const GET_DEGREE_REQUIREMENT_BY_ID = 'GET_DEGREE_REQUIREMENT_BY_ID';
export const UPDATE_DEGREE_REQUIREMENT = 'UPDATE_DEGREE_REQUIREMENT';
export const DELETE_DEGREE_REQUIREMENT = 'DELETE_DEGREE_REQUIREMENT';
export const CREATE_DEGREE_REQUIREMENT = 'CREATE_DEGREE_REQUIREMENT';
